//import Lock from "../../views/Lock";
import Pos from "./views/Pos";
import Login from "./views/Login";
import Busqueda from "./views/Busqueda";
import Requerimientos from "./views/Requerimientos";
import PagoPublicoRequerimientos from "./views/PagoPublicoRequerimientos.vue";
import Menu from "./views/Menu";
import MisPagos from "./views/MisPagos";
import Reportes from "./views/Reportes";
import PagoPublico from "./views/PagoPublico.vue";

// Deducibles
import BusquedaDeducibles from "./views/Deducibles/Busqueda";

// Recobros
import BusquedaRecobros from "./views/Recobros/Busqueda";
import CrearRecobro from "./views/Recobros/Creacion";
import MenuRecobro from "./views/Recobros/MenuRecobro";

// actualización ddatos
import ActualizacionDatos from "./views/ActualizacionDatos/Busqueda";

// Ruta de cobros
import RutaDeCobros from "./views/rutaCobros/RutasCobrosList";
import RutaDeCobrosCrear from "./views/rutaCobros/RutasCobrosCrear";

import Configuracion from "./views/Configuracion";

export default [
    {
        path: "/",
        component: Menu,
    },
    {
        path: "/login",
        component: Login,
        meta: {
            isPublic: true
        }
    },
    {
        path: "/menu",
        component: Menu,
    },
    {
        path: "/busqueda/:type/:search",
        component: Busqueda,
    },
    {
        path: "/busqueda/:type/:search/:extra",
        component: Busqueda,
    },
    {
        path: "/busqueda/:type/:search/:extra/:extrados",
        component: Busqueda,
    },
    {
        path: "/requerimientos/:poliza",
        component: Requerimientos,
    },
    {
        path: "/consulta/mis-pagos",
        component: MisPagos,
    },
    {
        path: "/reportes",
        component: Reportes,
    },

    //DEDUCIBLES
    {
        path: "/reclamos/:type/:search",
        component: BusquedaDeducibles,
    },
    {
        path: "/reclamos/:type/:search/:extra",
        component: BusquedaDeducibles,
    },
    {
        path: "/reclamos/:type/:search/:extra/:extrados",
        component: BusquedaDeducibles,
    },

    //Recobros
    {
        path: "/recobro-menu",
        component: MenuRecobro,
    },
    {
        path: "/recobro-crear",
        component: CrearRecobro,
    },
    {
        path: "/recobro/:type/:search",
        component: BusquedaRecobros,
    },
    {
        path: "/recobro/:type/:search/:extra",
        component: BusquedaRecobros,
    },
    {
        path: "/recobro/:type/:search/:extra/:extrados",
        component: BusquedaRecobros,
    },

    // actualización de datos
    {
        path: "/actualizacion-datos",
        component: ActualizacionDatos,
    },
    {
        path: "/actualizacion-datos/:type/:search",
        component: ActualizacionDatos,
    },

    // Ruta de cobros
    {
        path: "/ruta-cobros",
        component: RutaDeCobros,
    },
    // Ruta de cobros
    {
        path: "/ruta-cobros-create/:rutaid",
        component: RutaDeCobrosCrear,
    },
    // Configuracion
    {
        path: "/configuracion",
        component: Configuracion,
    },

    // pago público
    {
        path: "/mis-pagos",
        component: PagoPublico,
        meta: {
            isPublic: true
        }
    },
    {
        path: "/mis-pagos/:type/:search",
        component: PagoPublico,
        meta: {
            isPublic: true
        }
    },
    {
        path: "/mis-pagos-rq/:poliza",
        component: PagoPublicoRequerimientos,
        meta: {
            isPublic: true
        }
    },
];
